<template>
    <div class="mb-3">
        <template v-if="loading">
            <div class="row mb-4">
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="285px"></b-skeleton>
                </div>
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="285px"></b-skeleton>
                </div>
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="285px"></b-skeleton>
                </div>
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="285px"></b-skeleton>
                </div>
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="285px"></b-skeleton>
                </div>
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="285px"></b-skeleton>
                </div>
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="285px"></b-skeleton>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="258px"></b-skeleton>
                </div>
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="258px"></b-skeleton>
                </div>
                <div class="col">
                    <b-skeleton class="mb-2" animation="throb" height="45px"></b-skeleton>
                    <b-skeleton animation="throb" height="258px"></b-skeleton>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="cols-row">
                <div 
                    class="col-scroll-small" 
                    :style="item.styles ? item.styles : ''" 
                    v-for="(item, index) in largeCardsRowOne" 
                    :key="index"
                    :class="whatIsInvisibleCard(item.label)"
                >
                    <div class="card-report-name">
                        <h5 class="card-report__name card-title text-uppercase text-brown mb-2" v-tooltip="item.tooltip ? item.tooltip:''">
                            <template v-if="item.label == 'Рентабельность' || item.label == 'Маржа'">
                                {{item.label}}

                                <b-button
                                    @click="isRentabelnost = !isRentabelnost"
                                    size="sm"
                                    :variant="isRentabelnost ? 'outline-secondary':'outline-primary'"
                                    class="ml-2"
                                >
                                    <b-icon
                                        icon="back"
                                        scale="1"
                                    ></b-icon>
                                </b-button>
                            </template>
                            <template v-else>
                                {{item.label}}
                            </template>
                        </h5>
                    </div>
                    <div class="card card-report" :style="item.background ? 'height: 285px; background-color:'+item.background+' !important' : 'height: 285px'">
                        <div class="card-body card-body-report">
                            <template v-if="item.count_with_nds">
                                <h5 class="text-left text-orange font-weight-bold">
                                    <template v-if="item.ids.length > 0">
                                        <span class="cursor-pointer" @click="showByIds(item.ids, (item.label == 'Рентабельность' || item.label == 'Маржинальность поставок') ? 'financeGroupedByOrder' : 'finance', item.label)">
                                            {{countOrCountWithNDS(item, item.label) | toShortCurrency}} р.
                                        </span>
                                    </template>
                                    <template v-else>
                                        {{countOrCountWithNDS(item, item.label) | toShortCurrency}} р.
                                    </template>
                                </h5>
                                <ul class="text-left services-item mb-2" v-for="service in item.services">
                                    <li>
                                        <small class="text-brown" v-html="handlerLabelSmallCard(service.label)">{{service.label}}</small><br>
                                        <template v-if="service.ids.length > 0">
                                            <span class="font-weight-bold text-brown cursor-pointer" @click="showByIds(service.ids, (item.label == 'Рентабельность' || item.label == 'Маржинальность поставок') ? 'financeGroupedByOrder' : 'finance', `${item.label} (${service.label})`)">{{countOrCountWithNDS(service, item.label) | toShortCurrency}} р.</span>
                                        </template>
                                        <template v-else>
                                            <span class="font-weight-bold text-brown">{{countOrCountWithNDS(service, item.label) | toShortCurrency}} р.</span>
                                        </template>
                                    </li>
                                </ul>
                            </template>
                            <template v-else>
                                <h5 class="text-left text-orange font-weight-bold" style="font-size: 14px; max-width: 100%;">
                                    <scrolling-block-in-card-report>
                                        <template v-if="item.ids.length > 0 && item.type">
                                            <span v-if="item.label == 'Поставки'" :title="'Новые'" style="font-size: 1.125rem;" :class="item.label == 'Поставки' ? 'cursor-pointer slide-right-on-hover':'cursor-pointer'" @click="showByIds(item.ids, item.type, 'Новые поставки')">{{item.count}}</span>
                                            <span v-if="item.label == 'Заявки'" :title="'Новые'" style="font-size: 1.125rem;" :class="item.label == 'Заявки' ? 'cursor-pointer slide-right-on-hover':'cursor-pointer'" @click="showByIds(item.ids, item.type, 'Новые заявки')">{{item.count}}</span>
                                            <span v-if="item.label == 'Договоры'" style="font-size: 1.125rem;" :class="item.label == 'Договоры' ? 'cursor-pointer slide-right-on-hover':'cursor-pointer'" @click="showByIds(item.ids, item.type, 'Договоры')">{{item.count}}</span>
                                        </template>
                                        <template v-else>
                                            <span class="h5-small-text-work slide-right-on-hover" style="font-size: 1.125rem;">
                                                <span class="h5-small-number-text">{{item.count}}</span>
                                            </span>
                                        </template>
                                        <template v-if="item.label == 'Заявки'">
                                            <span class="h5-small-text-work slide-right-on-hover" v-if="suppliesAppends['bids_in_work_period']">/
                                                <span class="h5-small-number-text" :title="'В работе за период'">
                                                    <template v-if="suppliesAppends['bids_in_work_period'].all_orders_count == '' && suppliesAppends['bids_in_work_period'].all_orders_count != 0"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                                                    <template v-else>
                                                        <template v-if="suppliesAppends['bids_in_work_period'].all_orders_count == 0">
                                                            {{suppliesAppends["bids_in_work_period"].all_orders_count}}
                                                        </template>
                                                        <template v-else>
                                                            <span class="cursor-pointer" @click="showByIds(suppliesAppends['bids_in_work_period'].all_orders_ids, 'orders', 'Заявки в работе за период')">{{suppliesAppends["bids_in_work_period"].all_orders_count}}</span>
                                                        </template>
                                                    </template>
                                                </span>
                                            </span>
                                            <span class="h5-small-text-work slide-right-on-hover" v-if="suppliesAppends['bids_in_work']">/
                                                <span class="h5-small-number-text" :title="'В работе накопительные'">
                                                    <template v-if="suppliesAppends['bids_in_work'].all_orders_count == '' && suppliesAppends['bids_in_work'].all_orders_count != 0"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                                                    <template v-else>
                                                        <template v-if="suppliesAppends['bids_in_work'].all_orders_count == 0">
                                                            {{suppliesAppends["bids_in_work"].all_orders_count}}
                                                        </template>
                                                        <template v-else>
                                                            <span class="cursor-pointer" @click="showByIds(suppliesAppends['bids_in_work'].all_orders_ids, 'orders', 'Заявки в работе накопительные')">{{suppliesAppends["bids_in_work"].all_orders_count}}</span>
                                                        </template>
                                                    </template>
                                                </span>
                                            </span>
                                            <span class="h5-small-text-work text-danger slide-right-on-hover" v-if="suppliesAppends['bids_in_cancel']">/
                                                <span class="h5-small-number-text" :title="'Отказные за период'">
                                                    <template v-if="suppliesAppends['bids_in_cancel'].all_orders_count == '' && suppliesAppends['bids_in_cancel'].all_orders_count != 0"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                                                    <template v-else>
                                                        <template v-if="suppliesAppends['bids_in_cancel'].all_orders_count == 0">
                                                            {{suppliesAppends["bids_in_cancel"].all_orders_count}}
                                                        </template>
                                                        <template v-else>
                                                            <span class="cursor-pointer" @click="showByIds(suppliesAppends['bids_in_cancel'].all_orders_ids, 'orders', 'Отмененные заявки за период')">{{suppliesAppends["bids_in_cancel"].all_orders_count}}</span>
                                                        </template>
                                                    </template>
                                                </span>
                                            </span>
                                        </template>
                                        <template v-if="item.label == 'Поставки'">
                                            <span class="h5-small-text-work slide-right-on-hover" v-if="suppliesAppends['supplies_in_work']">/
                                                <span class="h5-small-number-text" :title="'В работе'">
                                                    <template v-if="suppliesAppends['supplies_in_work'].all_orders_count == '' && suppliesAppends['supplies_in_work'].all_orders_count != 0"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                                                    <template v-else>
                                                        <template v-if="suppliesAppends['supplies_in_work'].all_orders_count == 0">
                                                            {{suppliesAppends["supplies_in_work"].all_orders_count}}
                                                        </template>
                                                        <template v-else>
                                                            <span class="cursor-pointer" @click="showByIds(suppliesAppends['supplies_in_work'].all_orders_ids, 'orders', 'Поставки в работе')">{{suppliesAppends["supplies_in_work"].all_orders_count}}</span>
                                                        </template>
                                                    </template>
                                                </span>
                                            </span>
                                            <span class="h5-small-text-success slide-right-on-hover" v-if="suppliesAppends['supplies_in_success']">/
                                                <span class="h5-small-number-text" :title="'Завершено'">
                                                    <template v-if="suppliesAppends['supplies_in_success'].all_orders_count == '' && suppliesAppends['supplies_in_success'].all_orders_count != 0"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                                                    <template v-else>
                                                        <template v-if="suppliesAppends['supplies_in_success'].all_orders_count == 0">
                                                            {{suppliesAppends["supplies_in_success"].all_orders_count}}
                                                        </template>
                                                        <template v-else>
                                                            <span class="cursor-pointer" @click="showByIds(suppliesAppends['supplies_in_success'].all_orders_ids, 'orders', 'Поставки завершенные')">{{suppliesAppends["supplies_in_success"].all_orders_count}}</span>
                                                        </template>
                                                    </template>
                                                </span>
                                            </span>
                                            <span class="h5-small-text-success slide-right-on-hover" v-if="suppliesAppends['supplies_in_finalized']">/
                                                <span class="h5-small-number-text" :title="'Закрыто'">
                                                    <template v-if="suppliesAppends['supplies_in_finalized'].all_orders_count == '' && suppliesAppends['supplies_in_finalized'].all_orders_count != 0"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                                                    <template v-else>
                                                        <template v-if="suppliesAppends['supplies_in_finalized'].all_orders_count == 0">
                                                            {{suppliesAppends["supplies_in_finalized"].all_orders_count}}
                                                        </template>
                                                        <template v-else>
                                                            <span class="cursor-pointer" @click="showByIds(suppliesAppends['supplies_in_finalized'].all_orders_ids, 'orders', 'Поставки успешно закрытые')">{{suppliesAppends["supplies_in_finalized"].all_orders_count}}</span>
                                                        </template>
                                                    </template>
                                                </span>
                                            </span>
                                        </template>
                                    </scrolling-block-in-card-report>
                                </h5>
                                <ul class="text-left services-item mb-2" v-for="service in item.services">
                                    <li>
                                        <small class="text-brown" v-html="handlerLabelSmallCard(service.label)">{{service.label}}</small><br>
                                        <template v-if="service.ids.length > 0 && service.type">
                                            <span class="font-weight-bold text-brown cursor-pointer" @click="showByIds(service.ids, service.type, `${item.label} (${service.label})`)">{{service.count}}</span>
                                        </template>
                                        <template v-else>
                                            <span class="font-weight-bold text-brown">{{service.count}}</span>
                                        </template>
                                    </li>
                                </ul>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cols-row">
                <div class="col-scroll-small" :style="item.styles ? item.styles : ''" v-for="(item, index) in largeCardsRowTwo" :key="index">
                    <div class="card-report-name">
                        <h5 class="card-report__name card-title text-uppercase text-brown mb-2" v-tooltip="item.tooltip ? item.tooltip:''">{{item.label}}</h5>
                    </div>
                    <div class="card card-report" :style="item.background ? 'height: 285px; background-color:'+item.background+' !important' : 'height: 285px'">
                        <div class="card-body card-body-report">
                            <h5 class="text-left text-orange font-weight-bold" v-tooltip="{ content: mainNumbersTooltip(item, item.label) }">
                                <template v-if="item.loading && item.loading == true">
                                    <span class="text-flicker"><span>.</span><span>.</span><span>.</span></span>
                                </template>
                                <template v-else>
                                    <template v-if="item.ids.length > 0">
                                        <span class="cursor-pointer" @click="showByIds(item.ids, 'finance', item.label, item.order_to_manager)">
                                            {{countOrCountWithNDS(item, item.label) | toShortCurrency}} р.
                                        </span>
                                    </template>
                                    <template v-else>
                                        {{countOrCountWithNDS(item, item.label) | toShortCurrency}} р.
                                    </template>
                                </template>
                            </h5>
                            <ul class="text-left services-item mb-2" v-for="service in item.services">
                                <li v-tooltip="{ content: mainNumbersTooltip(service, item.label) }">
                                    <small class="text-brown" v-html="handlerLabelSmallCard(service.label)">{{service.label}}</small><br>
                                    <template v-if="item.loading && item.loading == true">
                                        <span class="text-flicker"><span>.</span><span>.</span><span>.</span></span>
                                    </template>
                                    <template v-else>
                                        <template v-if="service.ids.length > 0 && service.type">
                                            <span class="font-weight-bold text-brown cursor-pointer" @click="showByIds(service.ids, service.type, `${item.label} (${service.label})`, item.order_to_manager)">{{countOrCountWithNDS(service, item.label) | toShortCurrency}} р.</span>
                                        </template>
                                        <template v-else>
                                            <span class="font-weight-bold text-brown">{{countOrCountWithNDS(service, item.label) | toShortCurrency}} р.</span>
                                        </template>
                                    </template>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import ScrollingBlockInCardReport from './ScrollingBlockInCardReport.vue';

export default {
    props: {
        largeCardsRowOne: { type: Array },
        largeCardsRowTwo: { type: Array },
        suppliesAppends: {
            type: Object,
            required: false,
            default: () => ({
                'leads': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
                'bids': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
                'bids_in_work_period': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
                'bids_in_work': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
                'supplies': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
                'supplies_in_work': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
                'supplies_in_success': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
                'supplies_in_finalized': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
                'supplies_in_cancel': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
                'bids_in_cancel': {
                    'all_orders_count': '.',
                    'all_orders_ids': []
                },
            })
        },
        settingsMenu: { type: Object, required: true }
    },
    components: {
        ScrollingBlockInCardReport,
    },
    watch: {
        largeCardsRowOne() {
            this.loading = false
        },
    },
    data() {
        return {
            loading: false,
            isRentabelnost: true
        }
    },
    methods: {
        handlerLabelSmallCard(name) {
            switch (name) {
                case 'ТЭО':
                    return 'Логистика'
                case 'ТО':
                    return 'ТО'
                case 'С':
                    return 'Серт-ция'
                case 'К':
                    return 'Консалтинг'
                case 'ПНК':
                    return 'ПНК'
                case 'СВХ':
                    return 'СВХ'
                case 'Стр':
                    return 'Страх-ие'
                case 'Отработано':
                    return 'Отработано'
                case 'Не отработано':
                    return 'Не отработано'
                case 'Целевые':
                    return 'Целевые'
                case 'Не целевые':
                    return 'Не целевые'
            }
        },
        showByIds(ids, type = 'orders', label = 'Список', order_to_manager = null) {
            this.$emit("showByIds", ids, type, label, order_to_manager)
        },
        countOrCountWithNDS(item, label) {
            let noNdsLabels = ['Прибыль', 'Выручка', 'Рентабельность', 'Маржинальность поставок', 'Реализация']
            if (this.settingsMenu.cards.noNds.value) {
                noNdsLabels = [
                    'Прибыль', 'Выручка', 'Рентабельность', 'Маржинальность поставок', 'Реализация',
                    'Счета покупателям',
                    'Счета от поставщиков',
                    'Оплачено поставщикам',
                    'Задолженность покупателей',   // was closed early
                    'Задолженность покупателей 7 дней',
                    'Задолженность поставщикам',    // was closed early
                ]
            }
            if (noNdsLabels.includes(label)) {
                if (item.count_with_nds['RUB_ITOG']) {
                    return item.count_with_nds['RUB_ITOG']
                } else if (item.count_with_nds['RUB']) {
                    return item.count_with_nds['RUB']
                } else if (item.count_with_nds && typeof item.count_with_nds !== 'object') {
                    return item.count_with_nds
                }

                return 0
            } else {
                if (item.count['RUB_ITOG']) {
                    return item.count['RUB_ITOG']
                } else if (item.count['RUB']) {
                    return item.count['RUB']
                } else if (item.count && typeof item.count !== 'object') {
                    return item.count
                }

                return 0
            }
        },
        mainNumbersTooltip(item, label) {
            let html = ''

            if (label == 'Реализация') {
                if (item.count_realization_with_nds) {
                    html = `Перевыставлений ${item.count_realization_with_nds['RUB_ITOG']} р.`
                }
            }

            return html;
        },
        countOrCountWithNDSNoRubItog(item, label, valute = 'RUB') {
            switch (label) {
                case 'Задолженность покупателей':
                    if (item.count_with_nds[valute]) {
                        return item.count_with_nds[valute]
                    }

                    return 0
                default:
                    if (item.count[valute]) {
                        return item.count[valute]
                    }
                    return 0
            }
        },
        whatIsInvisibleCard(label) {
            if (label === 'Маржа' && this.isRentabelnost) {
                return 'd-none';
            } else if (label === 'Рентабельность' && !this.isRentabelnost) {
                return 'd-none';
            } else {
                return '';
            }
        }
    },
}
</script>
<style scoped>
    .card-title {
        font-size: 12px;
        font-weight: bold;
    }
    .slide2-right-on-hover {
        overflow: hidden;
        white-space:nowrap;
        display: inline-block;
    }
    .slide2-right-on-hover .hover-on-text {
        opacity: 0;
        max-width: 0;
        display: inline-block;
        transition: max-width .1s ease-out .1s, opacity .1s ease-out .1s, color;
        font-size: 10px;
        font-weight: normal;
    }
    .slide2-right-on-hover:hover .hover-on-text {
        opacity: 1;
        max-width: 150px;
        transition: max-width .5s ease-out .1s, opacity .5s ease-out .1s, color .2s;
    }
</style>
